const INTERCOM_APP_ID = 'gb4qsgn1'
export const restartIntercom = () =>{
    window?.Intercom('shutdown');
    window?.Intercom('boot', {  
        app_id: INTERCOM_APP_ID,
    });
}